import { DeliveryDate } from "./enquiry.model";
import { TubeExecution } from "./itemParametersValues.model";
import { MarketingGrade } from "./marketingGrades.model";
import { Material } from "./materials.model";
import { NormGrade } from "./normGrades.model";
import { NpsAndSchedule } from "./npsAndSchedules.model";
import { RawMaterialGrade } from "./rawMaterialGrades.model";

export class ItemsByEnquiryNo {
    items?: Items[];
}
export class DeliveryDateForSap {
    deliveryDate?: number;
    hasMultipleDeliveryDates?: boolean;
}
export class ItemSms {
    smsId?: number;
    name?: string;
    description?: string;
    marketingRoute?: string;
}

export class ItemMarketingFamily {
    marketFamilyId?: number;
    name?: string;
    description?: string;
    isDefaultForStock?: boolean;
    isDefaultForProject?: boolean;
}

export class ItemSurfaceType {
    surfaceTypeId?: number;
    name?: string;
    description?: string;
}

export class ItemMill {
    millId?: number;
    name?: string;
    shortName?: string;
    city?: string;
    country?: string;
}

export class ItemAttachment {
    attachmentId?: number;
    fileDate?: number;
    fileName?: string;
    presignedUrl?: string;
}

export class Items {
    itemNo?: string;
    customerItemNo?: string;
    remark?: string | null;
    alloySurcharge?: boolean;
    applicableNorms?: string;
    normGrades?: NormGrade[];
    marketingGrade?: MarketingGrade;
    rawMaterialGrade?: RawMaterialGrade;
    unitSystem?: string;
    quantity?: number;
    quantityUom?: string;
    od?: number;
    odUom?: string;
    wt?: number;
    wtUom?: string;
    id?: number;
    idUom?: string;
    npsSchedule?: NpsAndSchedule;
    typeOfTolerance?: string;
    lengthType?: string;
    lengthMin?: number;
    lengthMax?: number;
    lengthUom?: string;
    sms?: ItemSms;
    marketFamily?: ItemMarketingFamily;
    ut?: boolean | null;
    hydroTest?: boolean | null;
    endsCondition?: string;
    ht?: boolean | null;
    htAdditional?: boolean | null;
    inspectionType3dot2?: boolean | null;
    multipleCutting?: boolean | null;
    surfaceType?: ItemSurfaceType;
    mill?: ItemMill;
    totalWeight?: number;
    totalWeightUom?: string;
    optionDate?: number;
    customerDeliveryDate?: number;
    itrIssued?: boolean;
    icrIssued?: boolean;
    idrIssued?: boolean;
    feasibilityStatus?: string;
    costsStatus?: string;
    deliveryStatus?: string;
    attachments?: ItemAttachment[];
    tubeExecution?: TubeExecution;;
    wtToleranceMinus?: number;
    wtTolerancePlus?: number;
    feasibilityInfo?: string | null;
    deliveryDate?: number;
    deliveryDatesCollection?: DeliveryDate[];
    deliverySourceDescription?: string;
    marketingRoute?: string;
    material?: Material;
    finalPrice?: number;
    finalPriceUom?: string;
    finalPricePerLength?: number;
    finalPricePerLengthUom?: string;
    finalPricePerPiece?: number;
    finalPricePerPieceUom?: string;
    deliveryDateForSap?: DeliveryDateForSap;
}
